<template>
    <section class="fieldMap">
      <h2>Mapa</h2>
      <img src="map_fields.jpg" alt="mapa" width="1140" height="1280" />
      <svg
        xmlns:dc="http://purl.org/dc/elements/1.1/"
        xmlns:cc="http://creativecommons.org/ns#"
        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
        xmlns:svg="http://www.w3.org/2000/svg"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
        viewBox="0 0 1140 1280"
        version="1.2"
      >
        <g v-for="(field) in fields" :key="field.id">
          <rect :x="field.x" :y="field.y" :width="field.width" :height="field.height" :transform="`rotate(${field.rotation} ${field.x + field.width / 2} ${field.y + field.height / 2})`"/>
          <text :x="field.x + field.width / 2" :y="field.y + field.height / 2" text-anchor="middle" dominant-baseline="middle">{{ field.name }}</text>
          <title>{{ field.name }}</title>
        </g>
      </svg>
    </section>
  </template>
  
  <script>
  import { mapState } from 'vuex';
  
  export default {
    name: 'fieldMap',
    computed: {
      ...mapState(['fields']),
    },
  }
  </script>
    
  <style lang="scss">
  @import '../../sass/_constants.sass';
  
  .fieldMap {
    display: grid;
    justify-content: center;
    overflow-x: auto;
  
    img, svg {
      grid-column: 1;
      grid-row: 2;
    }
  
    svg rect {
      fill: $bc-warning;
    }
  }
  </style>
    